import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/userInfo.css';
import userIcon from '../../images/def_user_icon.svg';
import starIcon from '../../../assets/icons/star.svg';
import markerIcon from '../../../assets/icons/marker.svg';
import arrowIcon from '../../../assets/icons/right_arrow.svg';
import mapIcon from '../../../assets/icons/map.svg';

import BuildRouteModal from '../../modals/build_route/ui/Main';

import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import { getCountries } from '../../../api/location/getCountries';
import { getRegions } from '../../../api/location/getRegions';
import { getDistricts } from '../../../api/location/getDistricts';
import { getLocalizedName } from '../../../api/location/locationUtils';

const UserInfo = ({ user, locations }) => {
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const { i18n } = useTranslation();
    const currentLanguage = i18n.language;

    const [resolvedLocality, setResolvedLocality] = React.useState('');
    const [resolvedProvince, setResolvedProvince] = React.useState('');

    console.log(user)

    const handleNavigate = () => {
        if (user?.id) {
            navigate("/company", { state: { user } });
        }
    };

    const handleBuildRouteClick = () => {
        // Check authorization first - if not authorized, navigate to login page
        const accessToken = localStorage.getItem("access_token");
        if (!accessToken) {
            navigate('/sign');
            return;
        }
        setIsModalOpen(!isModalOpen);
    };

    React.useEffect(() => {
        let cancelled = false;

        const resolveLocation = async () => {
            // If textual location is already present (old structure), use it directly
            if (locations?.province || locations?.locality || locations?.area) {
                if (!cancelled) {
                    setResolvedLocality(locations.locality || locations.area || '');
                    setResolvedProvince(locations.province || '');
                }
                return;
            }

            // For new structure, try to resolve IDs via catalog
            const countryId = locations?.country_id;
            const regionId = locations?.region_id;
            const districtId = locations?.district_id;

            if (!countryId && !regionId && !districtId) {
                if (!cancelled) {
                    setResolvedLocality('');
                    setResolvedProvince('');
                }
                return;
            }

            try {
                let country = null;
                let region = null;
                let district = null;

                if (countryId) {
                    const countries = await getCountries();
                    country = countries.find((c) => c.id === countryId) || null;
                }

                if (regionId && countryId) {
                    const regions = await getRegions(countryId);
                    region = regions.find((r) => r.id === regionId) || null;
                }

                if (districtId && regionId) {
                    const districts = await getDistricts(regionId);
                    district = districts.find((d) => d.id === districtId) || null;
                }

                if (!cancelled) {
                    setResolvedLocality(district ? getLocalizedName(district, currentLanguage) : '');
                    setResolvedProvince(region ? getLocalizedName(region, currentLanguage) : '');
                }
            } catch (e) {
                if (!cancelled) {
                    setResolvedLocality('');
                    setResolvedProvince('');
                }
            }
        };

        resolveLocation();

        return () => {
            cancelled = true;
        };
    }, [locations, currentLanguage]);

    return (
        <div className="user_info_content">
            <h3>{t('user')}</h3>
            <div className="user_info_back_border">
                <div className="user_info_back">
                    <div className="user_info_profile_photo">
                        <img className="user_info_profile_photo_1" src={userIcon} alt="user_icon" />
                        <p className="online_user"></p>
                    </div>
                    <div className="user_info_profile_info click" onClick={handleNavigate}>
                        <p className="user_info_profile_info_name">{user?.name || 'Аноним'}</p>
                        <p className="user_info_profile_info_reg_date">
                            {t("memberSince", {
                                date: new Date(user.created_at).toLocaleDateString(t('locale'), {
                                    year: 'numeric',
                                    month: 'long'
                                })
                            })}
                        </p>
                        <span className="user_info_profile_info_status">{user?.status || t('offline')}</span>
                    </div>
                </div>
                <div className="user_rating">
                    <div className="rating_number">
                        <img src={starIcon} alt='star' />
                        <p className="margin0">{t('rating')} {String(user?.rating || '4.5').slice(0, 3)}</p>
                    </div>
                </div>
            </div>
            <div className="user_position">
                <h3>{t('location')}</h3>
                <div className="build_route_dropdown_wrapper">
                    <div
                        className="user_info_map_content click"
                        onClick={handleBuildRouteClick}
                    >
                        <div className="user_info_map_left">
                            <img src={markerIcon} alt='marker' />
                            <div className="user_info_map_left_texts">
                                <p className="user_info_map_left_text1">
                                    {locations?.locality || locations?.area || resolvedLocality || t('nothingFound')}
                                </p>
                                <p className="user_info_map_left_text2">
                                    {locations?.province || resolvedProvince || t('nothingFound')}
                                </p>
                            </div>
                        </div>
                        <img className='map_icon' src={mapIcon} alt='map' />
                    </div>
                    <BuildRouteModal
                        isOpen={isModalOpen}
                        onClose={() => setIsModalOpen(false)}
                        location={locations}
                    />
                </div>
            </div>
            <div className="announcement_message click" onClick={handleNavigate}>
                <p>{t('userAnnouncements')}</p>
                <img className='arrow' src={arrowIcon} alt='arrow' />
            </div>
        </div>
    );
};

export default UserInfo;